import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "time" }
const _hoisted_2 = { class: "number" }
const _hoisted_3 = { class: "number" }
const _hoisted_4 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pad(_ctx.hours)), 1),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dot" }, ":", -1)),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.pad(_ctx.minutes)), 1),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "dot" }, ":", -1)),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.pad(_ctx.seconds)), 1)
  ]))
}